/* ==========================================================================
   Makefield — feature rows lightbox
   --------------------------------------------------------------------------
   Binds Fancybox to the images and videos inside feature-row sections.

   Fancybox is bundled in assets/fancybox.js (not loaded from a CDN), so the
   lightbox keeps working even if third-party requests are blocked.

   Each row gets its own gallery via data-fancybox="<section>-<block>", so the
   arrows step through that row's images only.
   ========================================================================== */

(function () {
  'use strict';

  var SELECTOR = '[data-fancybox]';

  function bind() {
    // fancybox.js is deferred like this file, but load order is not
    // guaranteed on cached repeat views — bail out quietly and retry.
    if (typeof window.Fancybox === 'undefined') return false;
    if (!document.querySelector(SELECTOR)) return true;

    window.Fancybox.bind(SELECTOR, {
      Hash: false,
      Thumbs: { type: 'classic' },
      Toolbar: {
        display: {
          left: ['infobar'],
          middle: [],
          right: ['slideshow', 'fullscreen', 'close'],
        },
      },
      Carousel: {
        transition: 'slide',
      },
      // Respect users who have asked for less motion.
      animated: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    });

    return true;
  }

  function init() {
    if (bind()) return;

    // Fancybox has not parsed yet: poll briefly rather than failing silently.
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (bind() || tries > 40) window.clearInterval(timer);
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Re-bind when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector && event.target.querySelector(SELECTOR)) init();
  });
})();
